"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _productIcon = require("./product-icon");
Object.keys(_productIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _productIcon[key];
    }
  });
});